import {useMemo} from 'react';

import {useTranslation} from '../../../hooks';
import {IBreadcrumb} from '../components/Breadcrumb';
import {IMetroCategories} from '../types';

interface UseBreadcrumbsProps {
  categories: IMetroCategories | undefined;
  currentCategorySlug?: string | null;
}

export function useBreadcrums({categories, currentCategorySlug}: UseBreadcrumbsProps): IBreadcrumb[] {
  const {t} = useTranslation();
  return useMemo(() => {
    if (currentCategorySlug === 'favorite-product') {
      return [
        {label: t('MAIN'), href: '/metro'},
        {label: t('FAVORITE_PRODUCTS'), isCurrentPage: true},
      ];
    }

    if (!categories || currentCategorySlug === 'promo') {
      return [
        {label: t('MAIN'), href: '/metro'},
        {label: t('PROFITABLE_SHELF'), isCurrentPage: true},
      ];
    }

    if (!currentCategorySlug || !currentCategorySlug) return [];

    const findPath = (nodes: IMetroCategories, slug: string, path: IBreadcrumb[] = []): IBreadcrumb[] | null => {
      for (const node of nodes) {
        const currentPath = [...path, {label: node.name, href: `/categories/${node.slug}`}];
        if (node.slug === slug) return currentPath;
        if (node.children?.length) {
          const result = findPath(node.children, slug, currentPath);
          if (result) return result;
        }
      }
      return null;
    };

    const breadcrumbs: IBreadcrumb[] = [{label: t('MAIN'), href: '/metro'}];
    const categoryPath = findPath(categories, currentCategorySlug);
    if (categoryPath) breadcrumbs.push(...categoryPath);

    if (breadcrumbs.length > 0) {
      breadcrumbs[breadcrumbs.length - 1] = {
        ...breadcrumbs[breadcrumbs.length - 1],
        isCurrentPage: true,
      };
    }

    return breadcrumbs;
  }, [categories, currentCategorySlug, t]);
}
